import { api } from "utils/api";

import type { ContactUsDialogFormValues } from "./ContactUsDialog.types";

export const sendContactMessage = (payload: ContactUsDialogFormValues) => api.post("contact/package", { ...payload });
